import detectBrowser from '../__utils/detectBrowser';
import video from '../__utils/video';
import alertBar from '../__header/alertBar';
import MegaMenu from '../__header/MegaMenu';
import MobileHeader from '../__header/MobileHeader';
import stickyHeaderToggle from '../__header/stickyHeader';
import subnavDropdown from '../__header/subnavDropdown';
import InpageNav from '../__page/InpageNav';
import Accordion from '../__shortcodes/Accordions';
import Tabs from '../__page/Tabs';
import LightboxGallery from '../__page/LightboxGallery';
import { SimpleSlider, LightboxSlider, ProgramsSlider, customControlPrograms } from '../__utils/Sliders';
import smoothScroll from '../__utils/smoothScroll';
import Tables from '../__utils/Tables';
import forms from '../__utils/forms';
import { setVar } from '../__utils/setVar';
import { ctePrograms } from '../__page/ctePrograms';
import { AlumniSliderImage, AlumniSliderText } from '../__page/AlumniSlider';
import LightboxVideo from '../__page/LightboxVideo';
import ProgramsContent from '../__page/ProgramsContent';
import stepForm from '../__utils/stepForm';

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        document.querySelector('html').classList.remove('no-js');
        detectBrowser();
        smoothScroll();
        setVar();
        alertBar.init();
        subnavDropdown.init();
        stickyHeaderToggle();
        AOS.init()
        MegaMenu.init();
        MobileHeader.init();
        InpageNav.init();
        LightboxVideo.init();
        Accordion.init();
        Tabs.init();
        video.init();
        SimpleSlider.init();
        LightboxSlider.init();
        LightboxGallery.init();
        ProgramsSlider.init();
        Tables.init();
        ctePrograms();
        AlumniSliderImage.init();
        AlumniSliderText.init();
        ProgramsContent.init();
    },
    loaded() {
        document.querySelector('body').classList.add('page-has-loaded');
        customControlPrograms();
    },
    scrolled() {
        InpageNav.resized();
        stickyHeaderToggle();
    },
    resized() {
        setVar();
        MobileHeader.resized();
        InpageNav.scrolled();
        Tables.toggleShadow();
        Tabs.toggleShadow();
        LightboxGallery.refresh();
        MegaMenu.menuResizeToggle();
        stickyHeaderToggle();
    },
    mouseUp(e) {
        MobileHeader.hideOutsideClick(e);
        subnavDropdown.hideOutsideClick(e);
    },
    keyDown(e){
        LightboxGallery.keyDown(e);
        LightboxVideo.keyDown(e);
    },
    gformRender() {
        stepForm.init();
        forms.select();
    },
};
export default controller;
